const features = [
  {
    icon: 'ri-4k-line',
    title: '超清画质',
    desc: '支持1080P与4K超清播放，每一帧都纤毫毕现，还原综艺节目的最佳视觉体验。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '流畅不缓冲',
    desc: '独家CDN加速与智能预加载技术，秒开不卡顿，告别转圈等待，追综节奏不被打断。',
  },
  {
    icon: 'ri-timer-flash-line',
    title: '极速更新',
    desc: '同步卫视与网络平台播出，最快30分钟内上线，让你永远比朋友圈先一步看完。',
  },
  {
    icon: 'ri-stack-line',
    title: '海量资源',
    desc: '收录全网热门综艺10000+小时内容，从经典回顾到最新档期，想看的一搜就有。',
  },
  {
    icon: 'ri-vip-diamond-line',
    title: '完全免费',
    desc: '无需注册、无需会员、无需付费，打开网站即点即看，纯粹免费的高清综艺体验。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-100 mb-3">
            为什么选择6080影视
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            五大核心优势，为你打造极致的综艺观看体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="bg-background-50 rounded-xl p-5 border border-background-300/20 text-center transition-all duration-300 hover:border-primary-500/25 hover:translate-y-[-2px]"
            >
              <div className="w-12 h-12 mx-auto mb-3 rounded-lg bg-primary-500/10 flex items-center justify-center">
                <i className={`${feat.icon} text-primary-400 text-xl`}></i>
              </div>
              <h3 className="font-heading font-semibold text-sm text-foreground-200 mb-2">{feat.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}